<div class="container">
  <h4 class="my-4 d-block d-md-none">Agent Analytics Report</h4>
  <div class="row table-filter-bar mt-4">
    <div class="col-lg-6 col-md-12 col-12 d-flex align-items-center">
      <mat-form-field class="w-25">
        <mat-label>State</mat-label>
        <mat-select [(value)]="selectedState">
          <mat-option *ngFor="let state of constant.STATES | keyvalue" [value]="state.key">
            {{ $any(state).value | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="ml-3">
        <input matInput placeholder="FIPS" autocomplete="off" [(ngModel)]="fips" />
      </mat-form-field>
      <button mat-icon-button color="primary" class="ml-3" (click)="filterResult(selectedState, fips)">
        <mat-icon aria-label="Search">search</mat-icon>
      </button>
    </div>
    <div
      class="col-lg-6 col-md-12 mb-3 mb-lg-0 col-12 d-block d-lg-flex align-items-center justify-content-end Agent_filter"
    >
      <mat-label class="d-none d-md-inline-block">Show :</mat-label>
      <mat-radio-group (change)="activeCol = $event.value">
        <mat-radio-button value="recent" class="ml-md-3 mb-2 mb-md-0" color="primary" checked="true">
          <span class="p-2">Recent 12 months</span>
        </mat-radio-button>
        <mat-radio-button value="previous" class="ml-1 ml-md-3 mb-2 mb-md-0" color="primary">
          <span class="p-2">Previous 12 months</span>
        </mat-radio-button>
        <mat-radio-button value="both" class="ml-md-3 ml-1" color="primary"> Both </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="table_base mb-5">
    <div class="table-responsive table_wrap">
      <table
        mat-table
        multiTemplateDataRows
        [dataSource]="clientState.agentReport$ | async"
        class="mat-elevation-z2 w-100"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="align-left sticky sticky-col-1">Name</th>
          <td mat-cell *matCellDef="let element" class="align-left sticky sticky-col-1">
            {{ element.firstName + ' ' + element.lastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="activeCount">
          <th mat-header-cell *matHeaderCellDef class="align-center">Active</th>
          <td mat-cell *matCellDef="let element" class="align-center">{{ element.activeCount }}</td>
        </ng-container>
        <ng-container matColumnDef="pendingCount">
          <th mat-header-cell *matHeaderCellDef class="align-center">Pending</th>
          <td mat-cell *matCellDef="let element" class="align-center">{{ element.pendingCount }}</td>
        </ng-container>
        <ng-container matColumnDef="recentListingCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Listing
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.listingCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousListingCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Listing
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.listingCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentCancelledCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Cancelled
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.cancelledCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousCancelledCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Cancelled
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.cancelledCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentSoldCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Sold
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.soldCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousSoldCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Sold
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.soldCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentBuyCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Buy
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.buyCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousBuyCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Buy
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.buyCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentAvgListPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Avg. Listing Price
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.avgListPrice | currency: 'USD':'symbol':'1.0-0' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousAvgListPrice">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Avg. Listing Price
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.avgListPrice | currency: 'USD':'symbol':'1.0-0' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentAvgClosePrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Avg. Close Price
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.avgClosePrice | currency: 'USD':'symbol':'1.0-0' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousAvgClosePrice">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Avg. Close Price
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.avgClosePrice | currency: 'USD':'symbol':'1.0-0' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentSfrCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            SRF
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.sfrCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousSfrCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            SRF
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.sfrCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentThCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Townhome
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.thCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousThCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Townhome
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.thCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="recentCondoCount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="align-center"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
            [attr.colspan]="activeCol == 'both' ? 2 : false"
          >
            Condo
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-recent"
            [ngClass]="{ hidden: activeCol !== 'recent' && activeCol !== 'both' }"
          >
            {{ element.recent.condoCount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="previousCondoCount">
          <th mat-header-cell *matHeaderCellDef class="align-center" [ngClass]="{ hidden: activeCol !== 'previous' }">
            Condo
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="align-center cell-previous"
            [ngClass]="{ hidden: activeCol !== 'previous' && activeCol !== 'both' }"
          >
            {{ element.previous.condoCount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="agentTableColumnList.length">
            <div
              class="row expanded-agent-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
            >
              <div class="col-3">
                <p><strong>Office</strong></p>
                <p>{{ element.officeName }}</p>
                <p>{{ element.officeAddress }}</p>
              </div>
              <div class="col-3">
                <p><strong>License No. :</strong> {{ element.licenseNumber }}</p>
                <p><strong>MLS ID :</strong> {{ element.mlsId }}</p>
                <p><strong>Agent ID :</strong> {{ element.pmxAgentId }}</p>
              </div>
              <div class="col-3">
                <p><strong>Region :</strong> {{ element.county }} {{ element.state }}</p>
                <p>
                  <strong>{{ element.regionType | titlecase }} :</strong> {{ element.regionValue }}
                </p>
                <p><strong>Report Date :</strong> {{ element.reportGenerationDate | date }}</p>
              </div>
              <div class="col-3">
                <p><strong>Address :</strong> {{ element.address }}</p>
                <p><strong>Email :</strong> {{ element.email }}</p>
                <p><strong>Phone :</strong> {{ element.phone }}</p>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="agentTableColumnList; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: agentTableColumnList"
          [class.example-expanded-row]="expandedElement === element"
          (click)="expandedElement = expandedElement === element ? null : element"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="agent-detail-row"></tr>
      </table>
    </div>
    <div class="no-data-placeholder text-center py-4" *ngIf="!(clientState.agentReport$ | async)?.length">
      <img src="assets/images/partnerholder.png" width="260px" />
      <h5>Your agent reports will be listed here</h5>
    </div>
    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[10, 20]"
      showFirstLastButtons
      [length]="clientState.agentReportTotalCount$ | async"
      (page)="filterResult(selectedState, fips)"
    >
    </mat-paginator>
    <div class="section-in-progress" *ngIf="isDataLoading">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div>
  </div>
</div>
